/**
 * O conteúdo do jogo: classes, armas, terrenos.
 *
 * O motor não lê arquivo nem conhece caminho. Recebe o conteúdo já carregado,
 * e é isso que permite ao servidor validar uma partida com exatamente o mesmo
 * conteúdo que o navegador usou para desenhá-la.
 */
/**
 * A arma que se bebe em vez de se equipar — a poção tática do acervo.
 *
 * O que distingue a poção do cajado de cura é alcançar a casa 0, a própria:
 * nenhuma arma faz isso, e nenhum cajado precisa disso.
 */
export function isConsumable(weapon) {
    return Boolean(weapon?.heals && weapon.range[0] === 0);
}
/** O item do RPG faz alguma coisa quando usado — cura PV ou condição. */
export function isUsableItem(item) {
    if (!item)
        return false;
    return (item.heal ?? 0) > 0 || (item.healRate ?? 0) > 0 || (item.cures?.length ?? 0) > 0;
}
/** O item tem lugar na bolsa: se usa, ou abre baú. */
export function isBattleItem(item) {
    return isUsableItem(item) || Boolean(item?.opensChests);
}
/** A chave que abre baú trancado, e some ao abrir — arma tática ou item. */
export function isChestKey(def) {
    return Boolean(def?.opensChests);
}
/** Terreno com custo 0 é intransponível — a convenção vem do pipeline. */
export const IMPASSABLE = 0;
export function isImpassable(terrain) {
    return terrain === undefined || terrain.cost <= IMPASSABLE;
}
/** Monta o conteúdo a partir de listas cruas, como o pipeline as produz. */
export function buildContent(input) {
    return {
        classes: new Map(input.classes.map((c) => [c.id, c])),
        weapons: new Map(input.weapons.map((w) => [w.id, w])),
        // Só o que tem lugar na bolsa: um item sem efeito em campo não é item do
        // motor, e deixá-lo aqui convidaria a tela a oferecê-lo.
        items: new Map((input.items ?? []).filter(isBattleItem).map((i) => [i.id, i])),
        terrain: new Map(Object.entries(input.terrain)),
        triangle: input.triangle,
    };
}
//# sourceMappingURL=content.js.map